import * as React from 'react'
import { TranslationProvider } from './TranslationContext'
import { TranslateFunction, setLang, Locale } from '@ds/base'
import { useHtmlLang } from '../useHtmlLang'

/*

    AppTranslationProvider is effectively a TranslationContext but uses the HTML DOM
    lang attibute to automatically determine the active locale.

    Apps which use this provider need to provide a function which fetches the translator
    (gets a dictionary from the server and wraps it in a translate function).

    App components which need to translate use the TranslateContext to get the translate function.

        const translate = useContext(TranslateContext)

        <div>{translate("sent")}</div>

*/

interface Props {
  fetchTranslate: (locale: Locale) => Promise<TranslateFunction>
}

export const AppTranslationProvider: React.FunctionComponent<Props> = (
  props
) => {
  const [loadedLocale, setLoadedLocale] = React.useState('')
  const [translateFn, setTranslateFn] = React.useState<TranslateFunction>(
    (textId: string) => textId
  )
  const lang = useHtmlLang() || 'en'

  if (loadedLocale !== lang) {
    props
      .fetchTranslate(lang)
      .then((fn) => {
        setLoadedLocale(lang)
        setTranslateFn(() => fn)
      })
      .catch(() => {
        // reset the lang back to the original if we can't get the translations!
        setLang(loadedLocale)
      })
  }

  return (
    <TranslationProvider translate={translateFn}>
      {props.children}
    </TranslationProvider>
  )
}
